/**
 * WordPress dependencies
 */
 import { Guide } from '@wordpress/components';
 import { createElement } from '@wordpress/element';
 import { __ } from '@wordpress/i18n';
 import { useDispatch } from '@wordpress/data';
 
 export default function CustomWelcomeGuide() {
	 const { toggleFeature } = useDispatch( 'core/edit-post' );
 
	 function WelcomeGuideImage(_ref) {
		let {
			nonAnimatedSrc,
			animatedSrc
		} = _ref;
		return wp.element.createElement(
			"picture",
			{ className: "edit-widgets-welcome-guide__image" },
			wp.element.createElement(
				"source",{
					srcSet: nonAnimatedSrc,
					media: "(prefers-reduced-motion: reduce)"
				}),
				wp.element.createElement(
					"img", {
						src: animatedSrc,
						width: "312",
						height: "240",
						alt: ""
					}
				)
	)
	}

	 return (
		 <Guide
			 className="edit-post-welcome-guide"
			 contentLabel={ __( 'Bienvenue dans l\'éditeur de modèle de WP-Apidae' ) }
			 finishButtonText={ __( 'Get started' ) }
			 onFinish={ () => {
				 toggleFeature( 'customWelcomeGuide' );
			 } }
			 pages={ [
					{
						image:wp.element.createElement(
							WelcomeGuideImage, {
								nonAnimatedSrc: "https://wp-apidae.io/wp-content/uploads/welcome/welcome.svg",
								animatedSrc: "https://wp-apidae.io/wp-content/uploads/welcome/welcome.png"
							}
        		),
						content : (
							<>
							<h1 class="edit-post-welcome-guide__heading">Bienvenue dans l'éditeur de modèle de WP-Apidae</h1>
							<p class="edit-post-welcome-guide__text">Mettez en forme simplement vos cartes et fiches Apidae avec Gutenberg.</p>
							</>
						)
					},
					{
						image:wp.element.createElement(
							WelcomeGuideImage, {
								nonAnimatedSrc: "https://wp-apidae.io/wp-content/uploads/welcome/first-card.svg",
       				animatedSrc: "https://wp-apidae.io/wp-content/uploads/welcome/first-card.png"
							}
        		),
						content : (
							<>
							<h1 class="edit-post-welcome-guide__heading">Construisez votre première carte.</h1>
							<p class="edit-post-welcome-guide__text">Prenez en main les 2 premiers blocs dynamique pour construire le design de votre carte. Vous pouvez aussi utiliser les blocs natif de Gutenberg.</p>
							</>
						)
					},
					{
						image:wp.element.createElement(
							WelcomeGuideImage, {
								nonAnimatedSrc: "https://wp-apidae.io/wp-content/uploads/welcome/dynamic-content.svg",
       				animatedSrc: "https://wp-apidae.io/wp-content/uploads/welcome/dynamic-content.png"
							}
        		),
						content : (
							<>
							<h1 class="edit-post-welcome-guide__heading">Le blocs contenu dynamique.</h1>
							<p class="edit-post-welcome-guide__text">Il vous permet d'afficher des informations, directement prises dans les éléments de votre fiche. Choisissez le champs à afficher, le type de balise ainsi qu'une fonction de rappel si nécessaire.</p>
							</>
						)
					},
					{
						image:wp.element.createElement(
							WelcomeGuideImage, {
								nonAnimatedSrc: "https://wp-apidae.io/wp-content/uploads/welcome/dynamic-image.svg",
       					animatedSrc: "https://wp-apidae.io/wp-content/uploads/welcome/dynamic-image.png"
							}
        		),
						content : (
							<>
							<h1 class="edit-post-welcome-guide__heading">Le blocs image dynamique.</h1>
							<p class="edit-post-welcome-guide__text">Il vous permet d'afficher l'image à la une de votre fiche. Choisissez la taille de l'image que vous souhaitez. Définissez une image par défaut quand vos fiches n'ont pas de photos.</p>
							</>
						)
					},
					{
						image:wp.element.createElement(
							WelcomeGuideImage, {
								nonAnimatedSrc: "https://wp-apidae.io/wp-content/uploads/welcome/single-editor.svg",
       					animatedSrc: "https://wp-apidae.io/wp-content/uploads/welcome/single-editor.png"
							}
        		),
						content : (
							<>
							<h1 class="edit-post-welcome-guide__heading">Mettez en forme vos fiches.</h1>
							<p class="edit-post-welcome-guide__text">Utilisez les blocs de la rubrique "WP-Apidae blocs Single", pour mettre en forme et sélectionner les données que vous souhaitez afficher.</p>
							</>
						)
					},
			 ] }
		 />
	 );
 }